module.exports = {template: '<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.286h20V0H0v14.286zM16.85 1.65l1.054 1.01-4.701 4.506 4.652 4.46-1.054 1.01-4.652-4.46-2.146 2.057L10 10.23l-.002.002L7.85 8.176l-4.653 4.46-1.054-1.01 4.654-4.46L2.096 2.66l1.053-1.01L10 8.216l6.85-6.566z" fill-rule="evenodd"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_email1.svg
// module id = 1004
// module chunks = 1 4 5 9